/* eslint-disable */
import React, { useState, useEffect, useLayoutEffect, Suspense } from 'react'

// Styling
import styled from 'styled-components'

// Import YapContentBuilder components
import { YapContentBuilder, 
    YapContentValidations, 
    YapContentPreviewsModal,
    YapContentPreview,
    YapPage, 
    YapHeader,
    YapContextMenu,
    YapContextMenuOption,
    YapHeaderButton,
    YapNotification,
    YapAssetType,
    useYapPageState,
    YapUIGenerator,
    DocumentYapUI,
    useCanvas,
    useAppState,
    YapSectionAdd
} from '@yapstudios/yap-content-builder'
import { useUserAssets } from '../Backend.js'
import { YapUIComponent } from './YapUIComponent.js'
import { YapUIPageRenderer } from './YapUIPageRenderer.js'  
import { inspectorDefaultsForComponentName, encodeComponent } from "../YapDesigner.js"
import AST from '../YapUI/YapUIAST.js'

const defaultPage = [ { id: 'page1', name: 'Page 1', sections: [ ] } ]
/**
 * View Model
 * @param {*} param0 
 * @returns 
 */
export function useComposer({ componentItems, allItems, projectId, runtime, item, updateItem, viewCallback, assetCallback, itemCallback}) {
    const [showDebug, setShowDebug] = useState(false)
    const [pages, setPages ] = React.useState(item?.pages ?? defaultPage)

    const [yapuiJSON, setYapUIJSON] = React.useState(null)
    const [selectedPageId, setSelectedPageId] = React.useState(null)

    // Registered components that can be rendered
    const [components, setComponents] = React.useState([])  

    // Template info that users can choose components from
    const [componentTemplates, setComponentTemplates] = React.useState([])  

    const defaultsCallback = (componentName) => {   
        return inspectorDefaultsForComponentName(componentName, componentItems)
    }

    /**
     * Creates content builder components from the yapui items
     */
    const createComponents = (componentItems) => {
        //console.log('createComponents', componentItems) 
        const components = componentItems.map((componentType) => {    
            //console.log(' |_ ', componentType.name)
            return new YapUIComponent({ name: componentType.name, 
                                        path: componentType.path, 
                                        metadata: componentType.metadata,
                                        inspector: componentType.inspector,
                                        thumbnail: componentType.thumbnail,
                                        yapui: componentType.content, 
                                        viewCallback: viewCallback, 
                                        assetCallback: assetCallback,
                                        runtime: runtime,
                                        defaultsCallback: defaultsCallback  })
        })
        setComponents(components)   

        let componentGroups = groupComponents(components)

        const componentTemplates = componentGroups.map((group) => { 
            return { title: group.name, columns: 2, components: group.components.map((component) => { return { template: component, title: component.metadata?.name ?? component.name } }) }
        })
        setComponentTemplates(componentTemplates)

    }   

    useEffect(() => {   
        if (componentItems) {
            createComponents(componentItems)
        }
        if (item) {
            setPages(item?.pages ?? defaultPage)

            if (item?.content) {
                setYapUIJSON(item.content)
            }
        }

        return () => {

        }
    }, [item?.id])

    const composerFrame = item?.composerFrame ?? 'ComposerFrame'
    const composerFrameName = composerFrame.split('/').pop()

    //console.log('composerFrame', composerFrame, composerFrameName)  

    var pageInspector = null
    if (itemCallback) {
        let item = itemCallback(composerFrame)
        if (item && item.inspector) {
            pageInspector = item.inspector
        }
    }

    const pageRenderer = new YapUIPageRenderer({ components: components, 
                                                 viewCallback: viewCallback, 
                                                 assetCallback: assetCallback, 
                                                 defaultsCallback: defaultsCallback, 
                                                 inspectorContent: pageInspector,
                                                 runtime: runtime, 
                                                 name: item?.name,
                                                 composerFrame: composerFrameName })

    const onPagesUpdated = (pages, userUpdated, yapUI) => { 

        let newItem = {...item, pages: pages, content: yapUI,  composerFrame: composerFrameName, thumbnailItem: composerFrameName, type: 'composer' }

        console.log('onPagesUpdated ', pages, newItem, yapUI)

        runtime.registerComponent(item.name, yapUI)

        updateItem(newItem)
        setPages(pages)
        setYapUIJSON(yapUI)
    }

    const onYapUIUpdated = (yapui) => { 
        console.log('yapui updated', yapui) 
        //let encoded = JSON.stringify(yapui)
        //updateItem({...item, json: encoded, body: encoded})
        //setYapUIJSON(yapui)
    }

    return { 
            showDebug, setShowDebug, 
            pages, setPages,
            onPagesUpdated, onYapUIUpdated,
            yapuiJSON, setYapUIJSON,
            selectedPageId, setSelectedPageId,
            components, componentTemplates, pageRenderer,
            projectId
        }
}

function groupComponents(components) {
    var groups = []
    for (const component of components) {
        let path = component.path
        let folderName = path.split('/')[path.split('/').length - 2]
         
        let categoryName = component.metadata?.category ?? folderName ?? 'Components' 
        let group = groups.find((group) => group.name == categoryName)
        if (!group) {
            group = { name: categoryName, components: [] }
            groups.push(group)
        }
        group.components.push(component)
    }
    return groups
}

/**
 * View
 * @param {} param0 
 * @returns 
 */
export function Composer({ composer }) {
    
    const { showDebug, setShowDebug,
            pages, setPages, onPagesUpdated,
            selectedPageId, setSelectedPageId,
            onYapUIUpdated,
            yapuiJSON, setYapUIJSON,
            projectId,
            components, componentTemplates, pageRenderer
    } = composer

    let assetLibrary = useUserAssets({ projectId: projectId })    
    
    const assetLibraryData = assetLibrary.assets ?? []
    const defaultTemplate = null
    const templateLibrary = []
    const fonts = []
    const styles = null
    const validations = []

    console.log('Asset Library ', assetLibraryData)

    const canAddAssetType = (assetType) =>  {
        return true
    }


    // onAssetImport callback
    // YapContentBuilder passes in the follow parameters 
    //
    // - file: HTML File object that represents the file selected by the user
    // - asset: Suggested dictionary for convenience to represent the asset object. Will contain id, type, title, dimensions.
    // - album: Album the user is currently in 
    // - progressCallback: Callback to call when upload progress changes. progressCallback(percentComplete);
    // - completeCallback: Callback to call when upload is complete. completeCallback(newAsset, error)
    //
    // Return value:
    //   Function to call that will be called if the upload is cancelled by the user
    //
    const onImport = (file, asset, album, progressCallback, completeCallback, errorCallback) => {
        
        // In this example app we're adding the album name to the asset itself.
        // This is just an implementation detail of this example.
        var asset = asset 
        const uploadTask = assetLibrary.fileUploader({
            file: file,
            asset: asset,
            progressCallback: progressCallback,
            completeCallback: completeCallback,
            errorCallback: errorCallback
        })

        // Return value to onAssetImport is a function that will be called if the upload is cancelled by the user
        return () => {
            uploadTask.cancel()
        }
    }

    const onAssetChange = (asset) => {
        console.log('onAssetChange', asset)
        assetLibrary.updateAsset(asset)
    }
    const onAssetDelete = (asset) => {
        console.log('onAssetDelete', asset)
        assetLibrary.deleteAsset(asset)
    }   
    const onDone = () => {
        console.log('onDone')
    }
    const canInsertComponent = (component) => {
        return true
    }   
    const showSidebar = false
    const multiplePages = false
 
    return (
        <YapPage>
            <ComposerContainer>
                    <YapContentBuilder components={components}  
                                componentTemplates={componentTemplates} 
                                pages={pages} 
                                onPagesUpdated={onPagesUpdated} 
                                yapuiJSON={yapuiJSON}
                                onYapUIJSONUpdated={onYapUIUpdated}
                                assets={assetLibraryData} 
                                defaultTemplate={defaultTemplate}
                                templates={templateLibrary} 
                                fonts={fonts}
                                styles={styles}
                                validations={validations}
                                canAddAssetType={canAddAssetType}
                                onAssetImport={onImport} 
                                onAssetChange={onAssetChange} 
                                onAssetDelete={onAssetDelete}
                                onDone={onDone} 
                                canInsertComponent={canInsertComponent}
                                showSidebar={showSidebar}
                                multiplePages={multiplePages}
                                pageRenderer={pageRenderer}
                                showDebug={showDebug}
                                onSelectedPageId={setSelectedPageId}
                                />
            </ComposerContainer>
        </YapPage>
    )
}


export function ComposerViewActions({ composer }) {
    const { setShowDebug, showDebug } = composer 

    const viewMenuIcon = (
        <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.64062 19.7344C3.77604 19.7344 3.11719 19.5104 2.66406 19.0625C2.21615 18.6198 1.99219 17.9714 1.99219 17.1172V7.625C1.99219 6.77083 2.21615 6.1224 2.66406 5.67969C3.11719 5.23177 3.77604 5.00781 4.64062 5.00781H17.9141C18.7786 5.00781 19.4349 5.23177 19.8828 5.67969C20.3307 6.1224 20.5547 6.77083 20.5547 7.625V17.1172C20.5547 17.9714 20.3307 18.6198 19.8828 19.0625C19.4349 19.5104 18.7786 19.7344 17.9141 19.7344H4.64062ZM4.78125 18H17.7656C18.1042 18 18.3646 17.9141 18.5469 17.7422C18.7292 17.5651 18.8203 17.2969 18.8203 16.9375V7.80469C18.8203 7.44531 18.7292 7.17969 18.5469 7.00781C18.3646 6.83073 18.1042 6.74219 17.7656 6.74219H4.78125C4.4375 6.74219 4.17448 6.83073 3.99219 7.00781C3.8151 7.17969 3.72656 7.44531 3.72656 7.80469V16.9375C3.72656 17.2969 3.8151 17.5651 3.99219 17.7422C4.17448 17.9141 4.4375 18 4.78125 18ZM12.5312 18.25V6.46094H14.1562V18.25H12.5312ZM15.7109 9.57031C15.5547 9.57031 15.4219 9.51562 15.3125 9.40625C15.2031 9.29688 15.1484 9.17188 15.1484 9.03125C15.1484 8.88542 15.2031 8.75781 15.3125 8.64844C15.4219 8.53906 15.5547 8.48438 15.7109 8.48438H17.2578C17.4141 8.48438 17.5469 8.53906 17.6562 8.64844C17.7656 8.75781 17.8203 8.88542 17.8203 9.03125C17.8203 9.17188 17.7656 9.29688 17.6562 9.40625C17.5469 9.51562 17.4141 9.57031 17.2578 9.57031H15.7109ZM15.7109 11.7188C15.5547 11.7188 15.4219 11.6641 15.3125 11.5547C15.2031 11.4453 15.1484 11.3177 15.1484 11.1719C15.1484 11.026 15.2031 10.901 15.3125 10.7969C15.4219 10.6875 15.5547 10.6328 15.7109 10.6328H17.2578C17.4141 10.6328 17.5469 10.6875 17.6562 10.7969C17.7656 10.901 17.8203 11.026 17.8203 11.1719C17.8203 11.3177 17.7656 11.4453 17.6562 11.5547C17.5469 11.6641 17.4141 11.7188 17.2578 11.7188H15.7109ZM15.7109 13.8594C15.5547 13.8594 15.4219 13.8073 15.3125 13.7031C15.2031 13.5938 15.1484 13.4661 15.1484 13.3203C15.1484 13.1745 15.2031 13.0495 15.3125 12.9453C15.4219 12.8359 15.5547 12.7812 15.7109 12.7812H17.2578C17.4141 12.7812 17.5469 12.8359 17.6562 12.9453C17.7656 13.0495 17.8203 13.1745 17.8203 13.3203C17.8203 13.4661 17.7656 13.5938 17.6562 13.7031C17.5469 13.8073 17.4141 13.8594 17.2578 13.8594H15.7109Z" fill="#374DC0"/>
        </svg>   
    )

    const viewMenu = (
        <YapContextMenu action={<YapHeaderButton>{viewMenuIcon}</YapHeaderButton>}>
            <YapContextMenuOption onClick={() => { setShowDebug(true) }} title="Debug On" checked={showDebug}/>
            <YapContextMenuOption onClick={() => {  setShowDebug(false) }} title="Debug Off" checked={showDebug == false}/>
        </YapContextMenu>
    )

    return viewMenu
}


const ComposerContainer = styled.div`
    background-color: #f5f5f5;  
    width: -webkit-fill-available;
    height: -webkit-fill-available;
    display: flex;

    .floating-overlay {
        width: 100%;
        padding-right: 50px;
        z-index: 1;
    }
    
    .floating-overlay-inner-content {
        top: 0px !important;
    }
`
